// extracted by mini-css-extract-plugin
export default {"root":"InputAdd_root__mrcqt"};